import { I18nResource } from '@/i18n/i18n-supported-language';
import { Language } from '@/model/Translation.model';

interface UserLanguageResource {
  validResource: I18nResource[];
  defaultResource: I18nResource;
}
const i18nLanguageResourceMap: Record<Language, UserLanguageResource> = {
  [Language.TH]: {
    validResource: [I18nResource.TH_TH, I18nResource.EN_US],
    defaultResource: I18nResource.TH_TH,
  },
  [Language.EN]: {
    validResource: [I18nResource.EN_US],
    defaultResource: I18nResource.EN_US,
  },
  [Language.ZH]: {
    validResource: [I18nResource.EN_US],
    defaultResource: I18nResource.EN_US,
  },
  [Language.TR_TR]: {
    validResource: [I18nResource.EN_US],
    defaultResource: I18nResource.EN_US,
  },
  [Language.KO_KR]: {
    validResource: [I18nResource.KO_KR],
    defaultResource: I18nResource.KO_KR,
  },
  [Language.JA_JP]: {
    validResource: [I18nResource.JA_JP],
    defaultResource: I18nResource.JA_JP,
  },
  [Language.HI_IN]: {
    validResource: [I18nResource.HI_IN],
    defaultResource: I18nResource.HI_IN,
  },
};

export function getI18nResourceByLanguage(language: Language) {
  return i18nLanguageResourceMap[language];
}
